import SliderContainer from './slider_container';

const Slider = SliderContainer;
export default Slider;
